<template>
  <div class="space-y-3">
    <button
      @click="store.newContent()"
      class="w-full text-sm bg-teal-600 text-white rounded px-3 py-2 hover:bg-teal-700 font-medium"
    >+ New Content</button>

    <div v-if="!store.projectContents.value.length" class="text-sm text-gray-500 italic">
      No content yet for this project.
    </div>

    <div
      v-for="item in store.projectContents.value"
      :key="item.id"
      @click="handleSelect(item)"
      class="group cursor-pointer rounded border px-3 py-2 text-sm transition-colors relative"
      :class="item.id === store.currentContent.value?.id
        ? 'border-teal-500 bg-teal-50 text-teal-900'
        : 'border-gray-200 bg-white text-gray-800 hover:border-gray-300 hover:bg-gray-50'"
    >
      <button
        @click.stop="handleDelete(item)"
        class="absolute top-2 right-2 p-1 rounded text-gray-400 hover:text-red-600 hover:bg-red-50 opacity-0 group-hover:opacity-100 transition-all"
        title="Delete content"
      >
        <Trash2 :size="13" />
      </button>
      <div class="flex items-center gap-1 pr-6">
        <span class="font-medium flex-1">{{ item.title || briefExcerpt(item.brief) || 'Untitled' }}</span>
        <span v-if="item.rating" class="flex items-center gap-0.5 shrink-0">
          <Star :size="12" class="fill-amber-400 text-amber-400" />
          <span class="text-xs text-amber-600">{{ item.rating }}</span>
        </span>
      </div>
      <div class="flex items-center gap-2 mt-1">
        <span class="text-xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">{{ formatLabel(item.format) }}</span>
        <span v-if="item.author_name" class="text-xs text-gray-500 truncate">{{ item.author_name }}</span>
        <span v-if="item.cms_pushed_at" class="text-xs px-1.5 py-0.5 rounded bg-green-100 text-green-700">Published {{ formatDate(item.cms_pushed_at) }}</span>
        <span v-else class="text-xs text-gray-400">{{ formatDate(item.updated_at) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { Star, Trash2 } from 'lucide-vue-next'

const store = inject('workbench')

function briefExcerpt(brief) {
  if (!brief) return null
  return brief.length > 60 ? brief.slice(0, 60) + '...' : brief
}

function formatLabel(f) {
  if (!f) return ''
  return f.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

async function handleSelect(item) {
  if (!store.currentProject.value) return
  await store.loadContent(store.currentProject.value.id, item.id)
}

async function handleDelete(item) {
  const name = item.title || briefExcerpt(item.brief) || 'Untitled'
  if (!confirm(`Delete "${name}" and all its versions? This cannot be undone.`)) return
  await store.deleteContent(item.id)
}
</script>
